import { useNavigate } from "react-router-dom";

function Header({ onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout(); // Clear authentication state
    navigate("/signin"); // Redirect to sign-in page
  };

  return (
    <header className="w-full flex justify-between items-center bg-grey-400 shadow-md px-6 py-2">
      {/* Logo / App Name */}
      <h1 className="text-2xl font-bold text-indigo-600">AlphaGamesLab</h1>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="px-4 py-2 text-white bg-blue-600 hover:bg-red-600 rounded-md"
      >
        Logout
      </button>
    </header>
  );
}

export default Header;
